import {type PlaylistDoc, PlaylistDocSchema} from "@repo/shared";

import {BaseCollectionConfig} from "../BaseCollectionConfig";
import {collectionNameV2} from "../collectionName";
import {getByIdHookFactory} from "../factories/getByIdHookFactory";
import {getByIdRealtimeSubFactory} from "../factories/getByIdRealtimeSubFactory";
import {queryHookFactory} from "../factories/queryHookFactory";
import {queryRealtimeHookFactory} from "../factories/queryRealtimeHookFactory";

export class PlaylistCollectionConfig extends BaseCollectionConfig<
  typeof PlaylistDocSchema,
  unknown
> {
  constructor() {
    super(PlaylistDocSchema);
  }

  getCollection(): [string, ...(string | undefined)[]] {
    return [collectionNameV2("playlists")];
  }

  parser(id: string, data: any): PlaylistDoc {
    return {
      id,
      ...data,
      updatedAt: data?.updatedAt ?? new Date(),
    };
  }
}

const config = new PlaylistCollectionConfig();
export const usePlaylist = getByIdHookFactory(config);
export const usePlaylistRealtimeSub = getByIdRealtimeSubFactory(config);
export const usePlaylists = queryHookFactory(config);
export const useRealtimePlaylists = queryRealtimeHookFactory(config);
